import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

export const campaignOverview = z.object({
  campaign_creators_count: z.number(),
  campaign_creators_with_post_count: z.number(),
  tracked_posts_count: z.number(),
  recent_posts_count: z.number(),
});

export type CampaignOverview = z.infer<typeof campaignOverview>;

export async function FetchCampaignOverview(
  campaignId: string,
  signal?: AbortSignal,
): Promise<CampaignOverview> {
  const response = await socialApiClient.get(`campaigns/${campaignId}/overview`, {
    signal,
  });
  return campaignOverview.parse(await response.json());
}
